import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";
import { Trash2 } from "lucide-react";

export function ConfirmDialog({ open, onOpenChange, onConfirm, title = "Excluir este item?", description = "Esta ação não pode ser desfeita. O item será removido permanentemente do site.", itemName, confirmLabel = "Sim, excluir" }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="confirm-dialog" className="bg-[#131C2E] border-white/10 text-white rounded-2xl max-w-md">
        <AlertDialogHeader>
          <div className="w-11 h-11 rounded-xl bg-red-500/15 border border-red-500/30 flex items-center justify-center mb-2">
            <Trash2 className="w-5 h-5 text-red-300" />
          </div>
          <AlertDialogTitle className="text-white" data-testid="confirm-dialog-title">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-gray-400">
            {itemName && <span className="block text-gray-200 font-medium mb-1 truncate">"{itemName}"</span>}
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-dialog-cancel" className="bg-white/5 border-white/10 text-gray-300 hover:bg-white/10 hover:text-white rounded-lg">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="confirm-dialog-confirm" className="bg-red-500 hover:bg-red-600 text-white rounded-lg">{confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
